<template>
  <v-card class="mx-auto" flat>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <base-form-generator :schema="schema" />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
import BaseFormGenerator from '@/components/base/BaseFormGenerator';
export default {
  components: { BaseFormGenerator },
  props: {
    initValue: {
      default: () => {},
    },
    masters: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    schema() {
      const ptk = this.$getDeepObj(this.initValue, 'psp_profil.data.ptk.data') || {};
      return [
        {
          type: 'textView',
          label: `Akun SIMPKB`,
          labelColor: 'grey',
          value: +ptk.k_sumber === 1 ? ptk.no_ukg || ptk.ptk_id : this.initValue.email || '',
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'textView',
          label: `SIMPKB ID`,
          labelColor: 'grey',
          value: +ptk.ptk_id,
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'textView',
          label: `Nama Lengkap`,
          labelColor: 'grey',
          value: this.initValue.nama || '-',
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'textView',
          label: `Tempat Lahir`,
          labelColor: 'grey',
          value: this.initValue.tmp_lahir || '-',
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'textView',
          label: `Tanggal Lahir`,
          labelColor: 'grey',
          value: this.$localDate(this.initValue.tgl_lahir) || '-',
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'textView',
          label: `Jenis Kelamin`,
          labelColor: 'grey',
          value: this.initValue.kelamin ? (this.initValue.kelamin === 'L' ? 'Laki - laki' : 'Perempuan') : '-',
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'textView',
          label: `Alamat`,
          labelColor: 'grey',
          value: this.initValue.alamat || '-',
          grid: { cols: 12 },
        },
        {
          type: 'textView',
          label: `Provinsi`,
          labelColor: 'grey',
          value: (this.masters.propinsi && this.masters.propinsi[this.initValue.k_propinsi]) || '-',
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'textView',
          label: `Kota`,
          labelColor: 'grey',
          value: (this.masters.kota && this.masters.kota[this.initValue.k_kota]) || '-',
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'textView',
          label: 'Nomor Telepon (terhubung WhatsApp)',
          labelColor: 'grey',
          value: this.$getDeepObj(this.initValue, 'no_wa') || '-',
          grid: { cols: 12, md: 6 },
        },
      ];
    },
  },
};
</script>
